import React, { Component } from 'react';
import './ConfirmData.css';
import Navbar from '../Components/Navbar/Navbar'
import logoblue from '../../../image/logoblue.png'
import { Link } from 'react-router-dom';
import { LinkAPI } from '../../../API/API'
import axios from 'axios'
import HandleRes from '../Components/HandleRes/HandleRes';


class ForgetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      emailError: "",
    }
  }
  handleChange = event => {
    const isCheckbox = event.target.type === "checkbox";
    this.setState({
      [event.target.name]: isCheckbox
        ? event.target.checked
        : event.target.value
    });
  };

  validate = () => {
    let emailError = "";


    if (!this.state.email.includes("@")) {
      emailError = "ادخل بريد الالكتروني صحيح";
    }

    if (emailError) {
      this.setState({ emailError });
      return false;
    }

    return true;
  };

  handleSubmit = event => {
    event.preventDefault();
    const { email } = this.state
    const isValid = this.validate();
    if (isValid) {
      axios.post(`${LinkAPI}/api/businessowner/forgotpassword`,{
        email:email
      },{
        headers:{
          lang:"ar"
        }
      }
      ).then(res =>{
        window.location.replace("/AR/ConfirmData");

        }).catch(error=>{
          if (!error.response) {
            this.setState({
                networkError: true
            })
        } else if (error.response.status === 402) {
            window.location.replace("/Admin/SignIn");
        } else if (error.response.data.message) {
            this.setState({
                errordatamessage: true,
                errordatamessagetext: error.response.data.message
            })
        } else {
            this.setState({
                hasError: true,
            })
        }        })

    }
  };
  render() {
    document.title ="kayn | هل  لا ننذكر كلمة المرور ";
    document.getElementsByTagName("META")[1].content="كاين | هل  لا ننذكر كلمة المرور ";
    document.documentElement.lang = 'ar';
    return (
      <div className="AppAR signin">
        <Navbar />
        <div className='container'>
          <div className="Sign row my-0">
            
            <div className="col-md-6 form float-md-right  ">
              <div className="contantform text-center p-4 mt-150">
                <h3 className="fontsize1 my-4">ادخل البريد الالكتروني </h3>
                <form className="px-lg-5" onSubmit={this.handleSubmit}>
                  <div className="form-group my-4 ">
                    <input type="email" className={"form-control badge-pill p-3 noborder " + (this.state.emailError ? 'is-invalid' : '')} placeholder="البريد الالكتروني" name="email" value={this.state.email}
                      onChange={this.handleChange} required />
                    <div style={{ fontSize: 12, color: "red" }}>
                      {this.state.emailError}
                    </div>
                  </div>
                  {(this.state.errordatamessage ?
                      <div className="px-2" style={{ fontSize: 12, color: "red" }}>
                        {this.state.errordatamessagetext}
                      </div> : '')}
                  <button type="submit" className="btn btn-primary badge-pill btn-block shadow p-2 mb-2"  >ارسال</button>
                </form>



                <div className="mt-5 px-5">
                  <p className="fontsize6 my-4">لا تملك حسابا حتى الآن؟ </p>
                  <Link to="/AR/SignUp" className="btn badge-pill btn-block p-2 border shadow"  >سجل الان</Link>
                </div>
              </div>
            </div>
            <div className=" logoform col-6 d-flex align-content-end flex-wrap ">
              <div className="col-12 text-center mt-auto p-2 bd-highlight"><Link to="/AR/"><img className="logo" src={logoblue} alt="kayn" /></Link>       </div>
              <p className="fontsize2 text-center mb-5 col-12">طلبك الخاصة بك ... طريقك</p>
            </div>
          </div>
        </div>
{(this.state.errordataCodemessage ? <HandleRes title={this.state.errordatamessageCodetext} stylecss="alert-danger" /> : '')}

{(this.state.networkError ? <HandleRes title="تاكد باتصالك بالانترنت ثم عاود المحاوله" stylecss="alert-danger" /> : '')}
{(this.state.hasError ? <HandleRes title="  هناك مشكلة في طلبك" stylecss="alert-danger" /> : '')}

      </div>
    )
  }
}
export default ForgetPassword;